module.exports = __webpack_public_path__ + "img/20191120162527045.b78c3bdb.jpg";